module.exports = __webpack_public_path__ + "img/hr-deepwater-green-inner-corner.f9a19eab.png";